var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"action":"#"}},[_c('label',{attrs:{"data-state":_vm.state}},[_c('input',{attrs:{"type":"text","placeholder":"Search"},on:{"click":function($event){_vm.state = 'open'},"blur":function($event){_vm.state='close'}}}),_c('v-icon',{attrs:{"color":_vm.config.light.iconColor,"size":"28"}},[_vm._v("mdi-magnify")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }